<template>
  <div v-if="panelVisible" class="models-onboarding mb-6">
    <project-todo-list v-if="showEarlySteps" class="mb-4" />
    <v-alert v-if="loading" type="info" variant="tonal" density="compact">
      {{ $t('models_onboarding.loading') }}
    </v-alert>
    <v-alert
      v-else-if="statusError"
      type="error"
      variant="tonal"
      class="mb-3"
    >
      {{ $t('models_onboarding.status_error') }}
    </v-alert>
    <template v-else-if="status">
      <v-alert
        v-if="!status.images_present"
        type="warning"
        variant="tonal"
        class="mb-3"
      >
        {{ $t('models_onboarding.need_images') }}
        <template v-slot:append>
          <v-btn size="small" variant="text" :to="{ path: '/import' }">
            {{ $t('models_onboarding.go_import') }}
          </v-btn>
        </template>
      </v-alert>
      <v-alert
        v-else-if="!status.annotations_present"
        type="warning"
        variant="tonal"
        class="mb-3"
      >
        {{ $t('models_onboarding.need_annotations') }}
        <template v-slot:append>
          <v-btn size="small" variant="text" :to="{ path: '/annotate' }">
            {{ $t('models_onboarding.go_annotate') }}
          </v-btn>
        </template>
      </v-alert>
      <div v-else-if="showGenerateButton" class="text-center py-4">
        <p class="text-body-1 mb-4">{{ $t('models_onboarding.ready_hint') }}</p>
        <primary-button
          :loading="bootstrapping"
          @pressed="bootstrapTrainConfig"
        >
          {{ $t('models_onboarding.generate_button') }}
        </primary-button>
      </div>
    </template>
  </div>
</template>

<script>
import ProjectTodoList from '@/components/overview/ProjectTodoList.vue';
import PrimaryButton from '@/components/form/PrimaryButton.vue';

export default {
  name: 'ModelsOnboardingPanel',
  components: { ProjectTodoList, PrimaryButton },
  props: {
    showGenerateButton: { type: Boolean, default: true },
  },
  data() {
    return {
      status: null,
      statusError: false,
      loading: true,
      bootstrapping: false,
    };
  },
  computed: {
    showEarlySteps() {
      if (!this.status) {
        return true;
      }
      return !this.status.images_present || !this.status.annotations_present;
    },
    panelVisible() {
      if (this.loading || this.statusError) {
        return true;
      }
      if (this.showEarlySteps) {
        return true;
      }
      if (!this.status) {
        return false;
      }
      if (!this.status.images_present || !this.status.annotations_present) {
        return true;
      }
      return this.showGenerateButton;
    },
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      this.loading = true;
      this.statusError = false;
      try {
        this.status = await this.$api.onboarding.getStatus();
        if (!this.status) {
          this.statusError = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async bootstrapTrainConfig() {
      this.bootstrapping = true;
      try {
        const result = await this.$api.onboarding.bootstrapTrainConfig();
        if (result && result.error) {
          await this.loadStatus();
          const key = `models_onboarding.error_${result.error}`;
          const msg = this.$te(key) ? this.$t(key) : result.error;
          this.$store.dispatch('snackbars/add_failed_snack', msg);
          return;
        }
        this.$store.dispatch('snackbars/add_success_snack', {
          message: this.$t('models_onboarding.success'),
        });
        this.$emit('created');
      } finally {
        this.bootstrapping = false;
      }
    },
  },
};
</script>

<style scoped>
.models-onboarding {
  max-width: 100%;
}
</style>
